// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/808ff4413c070243152d.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"b9108abf0ba45142cd85","130":"f9106330f3f9e2cd497a","131":"6b51cd30cd1c341838f2"}[chunkId] + ".chunk.js";
};